const KEY = "shoptosa_price_history_v1";
const HISTORY_DAYS = 90;
const MIN_DAYS_FOR_REC = 7;

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

function num(val) {
  const n = Number(val);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function loadAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") || {};
  } catch {
    return {};
  }
}

export function recordLocal(listingId, price, currency = "USD") {
  const id = String(listingId || "");
  const amount = num(price);
  if (!id || amount == null || typeof localStorage === "undefined") return [];
  const all = loadAll();
  const day = todayKey();
  const rows = { ...(all[id] || {}) };
  rows[day] = { day, price: amount, currency: (currency || "USD").toUpperCase() };
  const start = new Date();
  start.setUTCDate(start.getUTCDate() - HISTORY_DAYS);
  const keepFrom = start.toISOString().slice(0, 10);
  for (const key of Object.keys(rows)) {
    if (key < keepFrom) delete rows[key];
  }
  all[id] = rows;
  localStorage.setItem(KEY, JSON.stringify(all));
  return Object.values(rows).sort((a, b) => a.day.localeCompare(b.day));
}

export function localSeries(listingId) {
  const rows = (loadAll()[String(listingId || "")] || {});
  return Object.values(rows).sort((a, b) => a.day.localeCompare(b.day));
}

export function mergePoints(...groups) {
  const byDay = {};
  for (const group of groups) {
    for (const raw of group || []) {
      const day = String(raw?.day || "");
      const price = num(raw?.price);
      if (!day || price == null) continue;
      byDay[day] = {
        day,
        price,
        currency: String(raw.currency || "USD").toUpperCase(),
      };
    }
  }
  return Object.keys(byDay).sort().map((k) => byDay[k]);
}

export function scoreHistory(points, current) {
  const vals = (points || []).map((p) => num(p.price)).filter((n) => n != null);
  const cur = num(current);
  if (cur != null) vals.push(cur);
  if (!vals.length) {
    return {
      enough: false,
      days: 0,
      highest: null,
      average: null,
      lowest: null,
      current: cur,
      cheap_score: 50,
      rec: "tracking",
      label: "We just started watching this price",
    };
  }
  const lowest = Math.min(...vals);
  const highest = Math.max(...vals);
  const average = vals.reduce((a, b) => a + b, 0) / vals.length;
  const unique = new Set(vals.map((n) => n.toFixed(2))).size;
  const days = new Set((points || []).map((p) => p.day).filter(Boolean)).size || (cur != null ? 1 : 0);
  const span = highest - lowest;
  const moved = unique >= 2 && span >= Math.max(average * 0.02, 0.5);
  const enough = days >= MIN_DAYS_FOR_REC || moved;
  let cheap = 50;
  if (enough && span > 0 && cur != null) {
    cheap = Math.max(0, Math.min(100, ((highest - cur) / span) * 100));
  }
  let rec = "tracking";
  let label = "We just started watching this price";
  if (enough && span <= 0) {
    rec = "fair";
    label = "Price has been stable";
  } else if (enough && cur != null && cur <= lowest * 1.08) {
    rec = "buy";
    label = "Go ahead & buy now";
  } else if (enough && cur != null && highest > lowest && cur >= highest * 0.9) {
    rec = "wait";
    label = "Wait for a better price";
  } else if (enough) {
    rec = "fair";
    label = "Fair price — not a historic low";
  }
  return {
    enough,
    days,
    highest,
    average,
    lowest,
    current: cur,
    cheap_score: cheap,
    rec,
    label,
  };
}

export function historyForProduct(product, serverHistory) {
  const id = product?.id;
  const local = recordLocal(id, product?.price, product?.currency || "USD");
  const points = mergePoints(serverHistory?.points, local);
  const scored = scoreHistory(points, product?.price);
  return {
    ...scored,
    points,
    currency: product?.currency || serverHistory?.currency || "USD",
  };
}
